import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OperationType } from '@helpers/Enums';
import { isFilledArray } from '@helpers/validation/arrayValidators';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import { Divider, Modal, Select } from 'antd';
import React from 'react';
import uuid from 'uuidv4';

import Condition from './Condition';
import { DividerStyler, ElseWrapper, OptionsWrapper, WorkflowConditions } from './WorkflowConditionsModalStyles';

interface PropType{
  visibility: boolean;
  availableProcess: any;
  onConditionsModalCancel: Function;
  currentConditionNexts: any;
  saveConditionInfo: Function;
  conditionData: any;
  clearConditionState: Function;
  }
  interface StateType {
    conditions: any;
    elseNext: string;
  }

export default class WorkflowConditionsModal extends React.Component<PropType, StateType>{
  constructor(props: PropType){
    super(props)
    this.state = {
      conditions: [{
        id: uuid(),
        operation: OperationType.AND,
        index: 1,
        next: undefined,
        rules: []
      }],
      elseNext: '',
    }
  }
  
  UNSAFE_componentWillReceiveProps(nextProps: any){
    if(nextProps.conditionData){
      this.setState({
        conditions: nextProps.conditionData.conditions,
        elseNext: nextProps.conditionData.elseNext})
    } if (isFilledArray(nextProps.currentConditionNexts) && nextProps.currentConditionNexts.length > this.state.conditions.length){
      const availableNextIds = this.state.conditions.map((condition: any) => condition.next);
      const availableNexts = nextProps.currentConditionNexts;
      let { conditions } = this.state;
      const { clearConditionState } = this.props;
      conditions = conditions.filter((condition: any) => condition.next)
      
      for(let i in availableNexts){
        if(availableNextIds.includes(availableNexts[i].id)) continue;
        
        const newCondition = {
            id: uuid(),
            operation: OperationType.AND,
            index: parseInt(i) + 1,
            next: availableNexts[i].id,
            rules: []
        }
        conditions.push(newCondition)
      }
      conditions = conditions.filter((condition: any) => condition)
      this.setState({ conditions, elseNext: availableNexts[0].id });
      // clearConditionState();
    }
  }
  
  componentDidMount() {
    if(this.props.conditionData){
      const { conditionData } = this.props
      this.setState({conditions: conditionData})
    }
  }

  createCondition = async () => {
    const newConditions = this.state.conditions

    const addedCondition = {
      id: uuid(),
      index: newConditions[newConditions.length - 1].index + 1,
      rules: []
    }

    newConditions.push(addedCondition)
    this.setState({conditions: newConditions})
  }
  
  deleteCondition = async (id: string) => {
    const newConditions:any = [];
    let hasDeletedCondition = false
    this.state.conditions.forEach((condition: any, i: number) => {
      if(condition.id === id){
        hasDeletedCondition = true;
      } else {
        if(hasDeletedCondition){
          const changedIndexCondition = Object.assign({}, condition, {index: condition.index - 1})
          newConditions.push(changedIndexCondition)
        } else {
          newConditions.push(condition)
        }
      }
      
    })
    this.setState({conditions: newConditions})
  }

  resetConditionState = async () => {
    const { onConditionsModalCancel } = this.props;
    
    const initialConditions = [{
      id: uuid(),
      operation: OperationType.AND,
      index: 1,
      rules: []
    }]

    this.setState({conditions: initialConditions})
    onConditionsModalCancel();
  }

  updateRules = async (id: string, updatedCondition: any) => {
    const { conditions } = this.state;
    const editedConditionIndex = conditions.findIndex((condition: any) => condition.id === id);
    const newCondition = Object.assign({}, conditions[editedConditionIndex], {rules: updatedCondition});
    this.checkForConditionFix(newCondition);
    conditions[editedConditionIndex] = newCondition

    this.setState({ conditions })
  }

  checkForConditionFix = (condition: any) => {
    let isFixed = true;

    if(condition.broken){
      for(let rule of condition.rules){
        if(!rule.operation || !rule.value || !rule.component_id){
          isFixed = false;
        }
      }
      if(isFixed){
        delete condition.broken
      }
    }
  }
  

  setConditionNext = async (value: any, id?: string) => {
    if(id){
      const { conditions } = this.state;
      const editedConditionIndex = conditions.findIndex((condition: any) => condition.id === id);
      const newCondition = Object.assign({}, conditions[editedConditionIndex], {next: value});
      conditions[editedConditionIndex] = newCondition;

      this.setState({conditions})
    } else {
      this.setState({elseNext: value})
    }
  }

  setNext = (next: any) => {
    this.setState({ next })
  }

  handleOperationType = async (value: number, id: string) => {
    const { conditions } = this.state;
    const editedConditionIndex = conditions.findIndex((condition: any) => condition.id === id)
    const newCondition = Object.assign({}, conditions[editedConditionIndex], {operation: value})

    conditions[editedConditionIndex] = newCondition;
    this.setState({ conditions })
  }
  
  validateConditions = () => {
    const { conditions, elseNext }= this.state
    let hasBrokenConditions = false; 
    if(elseNext){
    for(let condition of conditions){
        if(isFilledArray(condition.rules)){
          for(let rule of condition.rules){
            if(!rule.operation || !rule.value || !rule.component_id){
              hasBrokenConditions = true;
              condition.broken = true;
              this.setState({conditions})
              break;
            }
          }
        } else {
          hasBrokenConditions = true;
          condition.broken = true;
          NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('workflow.error.unfilled.condition.rules'))
          this.setState({conditions})
        }
        
    }
          } else {
            hasBrokenConditions = true;
            NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('workflow.error.no.else.next'))
          }

    return hasBrokenConditions;
  }

  setElseNext = async (elseNext: string) => { 
    this.setState({ elseNext })
  }
  
  onSave = async () => {
    const hasBrokenConditions = this.validateConditions()
    if(!hasBrokenConditions){
      const { saveConditionInfo } = this.props
      const { conditions, elseNext } = this.state
      saveConditionInfo(conditions, elseNext)
      this.resetConditionState()
    }
  }
  
  render(){
    const { visibility, availableProcess, currentConditionNexts } = this.props;
    const { conditions, elseNext } = this.state;
    const conditionsDeletion = conditions && conditions.length > 1;
    const { Option } = Select
    return (
      <WorkflowConditions>
        <Modal
        footer={false}
        className="section-condition-fullscreen"
        visible={visibility}
        onCancel={this.resetConditionState}
        >
          <div className="workflow-conditions">
            <header>
              <h1>{I18n.l('workflow.configure.condition')}</h1>
              <h2>{I18n.l('label.nameProcess')}</h2>
              <p className="process-description">{I18n.l('workflow.condition.text')}</p>
            </header>
                {conditions.map((condition: any) => 
                  (<div className="condition" key={condition.id+'-div'}>
                    <Condition 
                      key={condition.id}
                      condition={condition}
                      delete={conditionsDeletion}
                      deleteCondition={() => this.deleteCondition(condition.id)}
                      handleOperation={this.handleOperationType}
                      updateRules={this.updateRules}
                      availableProcess={availableProcess}
                      onCancel={this.resetConditionState}
                      currentConditionNexts={currentConditionNexts}
                      setConditionNext={this.setConditionNext}
                      setNext={this.setNext}
                    />
                  </div>)
                )}
                <DividerStyler>
                  {/* <NewCondition id="new-condition" onClick={this.createCondition}/> */}
                  <div className="left">
                    <Divider />
                  </div>
                  <div className="center">
                  <FontAwesomeIcon style={{opacity: 0.6, width: 20}} icon={'circle'} />
                  </div>
                  <div className="right">
                    <Divider />
                  </div>
                </DividerStyler>
                <ElseWrapper>
                  <div className="content">
                    <span className="text">{I18n.l('label.conditions.else')}</span>
                    <Select
                      className="select"
                      placeholder={I18n.l('formflow.components.goToComponent.selectGoToPlaceHolder')}
                      onChange={this.setElseNext}
                      id='else-next'
                      value={elseNext}>
                        {currentConditionNexts.map((next:any) => <Option key={next.id} value={next.id}>{next.title}</Option>)}
                    </Select>
                  </div> 
                </ElseWrapper>
                <OptionsWrapper>
                  <button className="ghost-button" id="condition-modal-cancel"onClick={this.resetConditionState}>
                    {I18n.l('common.cancel')}
                  </button>
                  <button  className="pill-button" id="condition-modal-save" onClick={this.onSave}>
                  {I18n.l('common.save')}
                  </button>
                </OptionsWrapper>
          </div>
        </Modal>
      </WorkflowConditions>
    )
  }
}
